'use strict'

import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { format } from 'date-fns';

import { appSelectors, appOperations } from '@/state/domains/app';
import { usersOperations, usersSelectors } from '@/state/domains/users';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Link from '@/views/common/Link';

import s from './styles.scss';

const roleLabels = {
	sysAdmin: 'System Admin',
	admin: 'Admin',
	dispatch: 'Dispatch',
	manager: 'Manager',
	server: 'Process Server',
	messanger: 'Messenger',
	gues: 'Guest',
};

const Main = connect(
	(state, props) => ({
	}),
	{
		getUsers: usersOperations.getUsers,
		setModalOpen: appOperations.setModalOpen
	}
)(
	({ getUsers, setModalOpen }) => {
		
		const [ users, updateUsers ] = useState([]);

		useEffect(
			() => {
				const p1 = getUsers({});

				Promise.all([ p1 ]).then(
					([ r1 ]) => {
						if (r1.success) {
							updateUsers(r1.data.users);
						}
					}
				);
			},
			[]
		);

		const updateUser = user => {
			const index = users.findIndex(u => u._id === user._id);
			if (index > -1) {
				updateUsers(Object.assign([], users, { [ index ]: user }))
			}
		};

		const removeUser = user => {
			const index = users.findIndex(u => u._id === user._id);
			if (index > -1) {
				updateUsers([
					...users.slice(0, index),
					...users.slice(index + 1)
				]);
			}
		};

		return (
			<div className={ s.root }>
				<div className={ s.tableCont }>
					<table className={ s.usersTable }>
						<thead className={ s.usersTableHead }>
							<tr>
								<th>First Name</th>
								<th>Last Name</th>
								<th>Username</th>
								<th>Roles</th>
								<th>Date Created</th>
								<th>Date Modified</th>
								<th>Actions</th>
							</tr>
						</thead>
						<tbody>
							{
								users.map(
									(u, i) => (
										<tr key={ i } className={ s.userRow }>
											<td>{ u.firstName }</td>
											<td>{ u.lastName }</td>
											<td>{ u.username }</td>
											<td className={ s.roles }>
												{
													u.roles.map(
														(r, i) => (
															<div
																key={ i }
																className={ s.role }
															>
																{ roleLabels[ r ] }
															</div>
														)
													)
												}
											</td>
											<td>
												{
													u.dateCreated && 
													format(
														new Date(u.dateCreated),
														'EEE MMM do y'
													)
												}
											</td>
											<td>
												{
													u.dateModified && 
													format(
														new Date(u.dateModified),
														'EEE MMM do y'
													)
												}
											</td>
											<td className={ s.actions }>
												<ul className={ s.actionsList }>
													<li
														className={ s.actionListItem }
														onClick={ () => setModalOpen('editUser', { user: u, updateUser }) }
													>
														<FontAwesomeIcon icon='pen-to-square' />
													</li>
													<li
														className={ s.actionListItem }
														onClick={ () => setModalOpen('deleteUser', { user: u, removeUser }) }
													>
														<FontAwesomeIcon icon='trash-can' />
													</li>
													<li className={ s.actionListItem }>
														<Link
															to={{ pathname: `/user/${ u.username }` }}
														>
															<FontAwesomeIcon icon='home' />
														</Link>
													</li>
												</ul>
											</td>
										</tr>
									)
								)
							}
						</tbody>
					</table>
				</div>
			</div>
		);
	}
);

export const components = {
	overlays: [
	],
	main: Main,
};

export default Main;
